export interface MaterialPreview {
  image: string
  title: string
  caption: string
  tag: string
}

export const materialPreviews: MaterialPreview[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/9mkLUMCiDphae7yJA57Twj/Captura_de_pantalla_2026-09-06_a_la(s)_11.35.49_p._m..png',
    title: 'Completa la Sequenza',
    caption: 'Esercizi graduati a livelli, con difficoltà segnalata dalle stelline.',
    tag: 'ESERCIZI',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/qLmaoAKpABjpRHnY1BWECN/Captura_de_pantalla_2026-09-06_a_la(s)_11.36.17_p._m..png',
    title: '30 Moltiplicazioni in Riga',
    caption: 'Schede di calcolo rapido pronte da stampare e cronometrare.',
    tag: 'CALCOLO VELOCE',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/5M1DiibZB6tQ2vVQMpe9we/Captura_de_pantalla_2026-09-06_a_la(s)_11.37.22_p._m..png',
    title: 'Galleria delle Formule',
    caption: 'Ogni formula spiegata con la figura che la giustifica.',
    tag: 'TEORIA',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/sc1n3rW9DY5w15V5PuUukx/Captura_de_pantalla_2026-09-06_a_la(s)_11.38.08_p._m..png',
    title: 'Unità 6 · Equivalenza e Aree',
    caption: 'Le unità complete con formule dirette e inverse illustrate.',
    tag: 'UNITÀ COMPLETA',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/68i4nJgEVGVvRAwHUT38sE/Captura_de_pantalla_2026-09-06_a_la(s)_11.38.47_p._m..png',
    title: 'Coordinate nel Piano Cartesiano',
    caption: 'Attività con griglie già disegnate: basta stampare e lavorare.',
    tag: 'GEOMETRIA',
  },
]
